import { useGetStorePaymentLogs } from '@/features/payment-management/store-payment-logs/hooks/useGetStorePaymentLogs';
import { StorePaymentLogsTable } from '@/features/payment-management/store-payment-logs/table';
import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';

const sortItemSchema = z.object({
  id: z.enum([
    'createdDate',
    'storeInfo',
    'storeName',
    'prefecture',
    'totalBookings',
    'visitDateTime',
    'totalPlanAmount',
    'commissionAmount',
    'commisionAmount',
    'totalAmount',
  ]),
  desc: z.boolean(),
});

const storesLogSchema = z.object({
  sort: z
    .preprocess((val) => {
      if (typeof val === 'string') {
        try {
          return JSON.parse(val);
        } catch {
          return undefined;
        }
      }
      return val;
    }, z.array(sortItemSchema))
    .optional(),

  createdDate: z.union([z.string(), z.array(z.string())]).optional(),

  q: z
    .any()
    .transform((val) => (val == null ? undefined : String(val)))
    .optional(),

  locationFilter: z.string().optional(),
  clubFilter: z.string().optional(),
  clubId: z.string().optional(),

  status: z
    .string()
    .transform((val) => val.split(','))
    .pipe(z.array(z.enum(['ACTIVE', 'BLOCKED'])))
    .optional(),

  page: z.coerce.number().nonnegative().catch(0),
  fetch: z.coerce.number().positive().catch(10),
});

export const Route = createFileRoute('/(app)/payment-management/store-payment-log/')({
  component: RouteComponent,

  validateSearch: (search: SearchSchemaInput) => storesLogSchema.parse(search),
});

function RouteComponent() {
  const { storePaymentLogs, isLoading, pagination } = useGetStorePaymentLogs();

  return (
    <div className="w-full h-full pb-3 md:pb-5 bg-background">
      <StorePaymentLogsTable data={storePaymentLogs} isLoading={isLoading} pagination={pagination} />
    </div>
  );
}
